import { getBrowserSupportTier } from '../utils/getBrowserSupportTier';

export function useLegacyBrowserBanner(): boolean {
  return getBrowserSupportTier() === 'legacy';
}
